module.exports = {
  /**
   * @description 网站标题
   */
  title: '数据存储专业委员会',
  /**
   * @description 是否显示 tagsView
   */
  tagsView: true,
  /**
   * @description 固定头部
   */
  fixedHeader: true,
  /**
   * @description 记住密码状态下的token在Cookie中存储的天数，默认1天
   */
  tokenCookieExpires: 1,
  /**
   * @description 记住密码状态下的密码在Cookie中存储的天数，默认1天s
   */
  passCookieExpires: 1,
  /**
   * @description 是否只保持一个子菜单的展开
   */
  uniqueOpened: true,
  /**
   * @description token key
   */
  TokenKey: 'FH_TOEKN',
  /**
   * @description user id
   */
  UserId: 'FH_USER_ID',
  /**
   * @description user name
   */
  UserName:'FH_USER_NAME',
  /**
   * @description 请求超时时间，毫秒（默认2分钟）
   */
  timeout: 1200000,
  /**
   * @description 是否显示logo
   */
  sidebarLogo: true,
  /**
   * 是否显示设置的底部信息
   */
  showFooter: true,
  /**
   * 底部文字，支持html语法
   */
  footerTxt: '中国电子工业标准化技术协会信息技术服务分会',
  /**
   * 备案号
   */
  caseNumber: '备案号：京ICP备06019433号-22',
  caseNumbers:'京公网安备 11010802040031号'
}
